import { createAction } from "redux-actions";

// Get current user
export const REQUESTED_CURRENT_USER = "REQUESTED_CURRENT_USER";
export const RECEIVED_CURRENT_USER = "RECEIVED_CURRENT_USER";

export const requestCurrentUsers = createAction(REQUESTED_CURRENT_USER);
export const receiveCurrentUsers = createAction(
  RECEIVED_CURRENT_USER,
  (currentUser) => ({ currentUser })
);

// Get user
export const REQUESTED_USERS = "REQUESTED_USERS";
export const RECEIVED_USERS = "RECEIVED_USERS";
export const REQUESTED_USER_BY_ID = "REQUESTED_USER_BY_ID";
export const RECEIVED_USER_BY_ID = "RECEIVED_USER_BY_ID";

export const requestUsers = createAction(REQUESTED_USERS);
export const receiveUsers = createAction(RECEIVED_USERS, (users) => ({
  users,
}));

export const requestUserById = createAction(REQUESTED_USER_BY_ID, (id) => id);
export const receiveUserById = createAction(RECEIVED_USER_BY_ID, (user) => ({
  user,
}));

// Create user
export const REQUESTED_CREATE_USER = "REQUESTED_CREATE_USER";
export const RECEIVED_CREATE_USER = "RECEIVED_CREATE_USER";

export const requestCreateUser = createAction(
  REQUESTED_CREATE_USER,
  (user) => ({
    user,
  })
);
export const receiveCreateUser = createAction(RECEIVED_CREATE_USER, (user) => ({
  user,
}));

export const REQUESTED_CURRENT_USER_FAILED = "REQUESTED_CURRENT_USER_FAILED";
export const REQUESTED_CREATE_USER_FAILED = "REQUESTED_CREATE_USER_FAILED";
export const REQUESTED_UPDATE_USER_FAILED = "REQUESTED_UPDATE_USER_FAILED";
export const REQUESTED_CLEAR_FAILED_MSG = "REQUESTED_CLEAR_FAILED_MSG";

// Update user
export const REQUESTED_UPDATE_USER = "REQUESTED_UPDATE_USER";
export const RECEIVED_UPDATE_USER = "RECEIVED_UPDATE_USER";

export const requestUpdateUser = createAction(
  REQUESTED_UPDATE_USER,
  (user) => ({
    user,
  })
);
export const receiveUpdateUser = createAction(RECEIVED_UPDATE_USER, (user) => ({
  user,
}));

// Delete user
export const REQUESTED_DELETE_USER = "REQUESTED_DELETE_USER";
export const RECEIVED_DELETE_USER = "RECEIVED_DELETE_USER";

export const requestDeleteUser = createAction(
  REQUESTED_DELETE_USER,
  (user) => ({
    user,
  })
);
export const receiveDeleteUser = createAction(RECEIVED_DELETE_USER, (user) => ({
  user,
}));
